import { DateTime } from 'luxon'

type RenderPortalStatusTextParams = {
  isSyncing: boolean,
  lastSyncDateObj: DateTime | null,
  lastSyncFailed: boolean,
}

export const renderPortalStatusText = (params: RenderPortalStatusTextParams) => {
  const { isSyncing, lastSyncDateObj, lastSyncFailed } = params

  if (lastSyncFailed) return 'Error with last sync'
  if (isSyncing && !lastSyncDateObj) return 'Sync queued'
  if (isSyncing && lastSyncDateObj) return `Last sync: ${lastSyncDateObj?.toFormat('dd MMM yyyy \'at\' h:mma')}`

  return 'Waiting to be published'
}

export default renderPortalStatusText
